// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"83":"31d6cfe0","602":"bdf6efd8"}[chunkId] + ".css";
};